export const MediaTypes = ['Webchat', 'Voice', 'Email', 'Messaging'] as const;

export type MediaType = (typeof MediaTypes)[number];
